// src/routes/CourierInvoiceRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Courier Invoice Components
import CreateCourierInvoicePage from '../pages/courierInvoice/CreateCourierInvoicePage';
import CourierInvoiceListPage from '../pages/courierInvoice/CourierInvoiceListPage';
import CourierInvoiceDetailsPage from '../pages/courierInvoice/CourierInvoiceDetailsPage';

const CourierInvoiceRoutes = () => {
  return (
    <Routes>
      {/* Courier Invoice List */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="view_all_courier_invoices">
            <CourierInvoiceListPage />
          </PermissionRoute>
        } 
      />
      
      {/* Create Courier Invoice */}
      <Route 
        path="/create" 
        element={
          <PermissionRoute requiredPermission="create_courier_invoice">
            <CreateCourierInvoicePage />
          </PermissionRoute>
        } 
      />
      
      {/* Courier Invoice Details */}
      <Route 
        path="/:id" 
        element={
          <PermissionRoute requiredPermission="view_courier_invoice">
            <CourierInvoiceDetailsPage />
          </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default CourierInvoiceRoutes;